import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/api';

const STORAGE_KEY = 'zakovat_auto_collapse';
const THEME_STORAGE_KEY = 'zakovat_theme';

export const THEME_OPTIONS = ['light', 'dark', 'system'];

function loadStoredTheme() {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    return THEME_OPTIONS.includes(stored) ? stored : 'light';
}

export const fetchUserSettings = createAsyncThunk(
    'settings/fetchUserSettings',
    async (_, { rejectWithValue }) => {
        try {
            return await apiService.userSettings.get();
        } catch {
            return rejectWithValue(null);
        }
    }
);

const settingsSlice = createSlice({
    name: 'settings',
    initialState: {
        autoCollapseAnswers: localStorage.getItem(STORAGE_KEY) !== '0',
        theme: loadStoredTheme(),
    },
    reducers: {
        setAutoCollapseAnswers: (state, action) => {
            state.autoCollapseAnswers = action.payload;
            if (!action.payload) {
                localStorage.setItem(STORAGE_KEY, '0');
            } else {
                localStorage.removeItem(STORAGE_KEY);
            }
        },
        setTheme: (state, action) => {
            if (THEME_OPTIONS.includes(action.payload)) {
                state.theme = action.payload;
                localStorage.setItem(THEME_STORAGE_KEY, action.payload);
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchUserSettings.fulfilled, (state, action) => {
            if (action.payload?.autoOpenAnswers !== undefined) {
                state.autoCollapseAnswers = action.payload.autoOpenAnswers;
                if (!action.payload.autoOpenAnswers) {
                    localStorage.setItem(STORAGE_KEY, '0');
                } else {
                    localStorage.removeItem(STORAGE_KEY);
                }
            }
            if (THEME_OPTIONS.includes(action.payload?.theme)) {
                state.theme = action.payload.theme;
                localStorage.setItem(THEME_STORAGE_KEY, action.payload.theme);
            }
        });
    },
});

export const { setAutoCollapseAnswers, setTheme } = settingsSlice.actions;
export const selectAutoCollapseAnswers = (state) => state.settings.autoCollapseAnswers;
export const selectTheme = (state) => state.settings.theme;
export default settingsSlice.reducer;